import angular from 'angular';

function ReferenceFormatter() {
    return function (reference) {
        var formattedReference = reference
            .replace('SUNTR-', 'SUNTR_')
            //delete after /
            .replace(new RegExp('\/.', 'gi'), '')
            .replace(' ', '')
            .toUpperCase();

        if (!formattedReference.match(/^SUNTR_/)) {
            formattedReference = 'SUNTR_' + formattedReference;
        }

        return formattedReference.match(/^SUNTR_[A-Za-z]{2}[0-9]{4}/)
            ? formattedReference
            : reference;
    };
}

const referenceFormatterFilter = angular.module('st.filters.referenceFormatter', [])
                                        .filter('ReferenceFormatter', ReferenceFormatter)
    .name;

export default referenceFormatterFilter;


// WEBPACK FOOTER //
// ./client/app/common/filters/referenceFormatter.js